// removed by extract-text-webpack-plugin
module.exports = {"baseButton":"baseButton--kqR6C","mintGreen":"mintGreen--N1BlE","marigold":"marigold--1Kt6A","raiseBlue":"raiseBlue--2rOSi","active":"active--aIB8B","clearWhite":"clearWhite--1TyVY"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-styles/buttons.scss
 ** module id = 176
 ** module chunks = 3 12 16 17
 **/